import React, { useState } from 'react'
import styled from 'styled-components'
import ModalCloseButton from 'components/buttons/ModalCloseButton'
import { useDispatch, useSelector } from 'react-redux'
import { createQASession, setViewCreateQASessionModal } from 'features/qaSessions/qaSessionSlice'
import { ModalFormTop, CreateItemModalHeading, ModalItemInput } from 'components/modal/modal.styled'
import { TbMessage2Question } from "react-icons/tb";
import TwoOptionButton from 'components/utils/TwoOptionButton' 
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select  from '@mui/material/Select';
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { ButttonWrap, FileUploadButton } from 'components/files/files.styled'
import SpinnerSmall from 'components/SpinnerSmall'
import toast from 'react-hot-toast'
import { EndAutomaticallyDiv, CreateQASessionWrap, OptionDescription, OptionsContainer, OptionsWrap, OptionsWrap2 } from './sessions.styled'
import { useTranslation } from 'react-i18next'

export default function CreateQASession() {
    const { t } = useTranslation('qna')

    const dispatch = useDispatch()
    
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { createQASessionStatus } = useSelector((state) => state.qASession)
    const [ questionVisibility, setQuestionVisibility ] = useState("public")
    const [ requireApproval, setRequireApproval ] = useState(true)
    const [ allowAnonymous, setAllowAnonymous ] = useState(true) 
    const [ endAutomatically, setEndAutomatically ] = useState(true)
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes ] = useState(10)
    const [ limitQuestions, setLimitQuestions ] = useState(false)
    const [ maxQuestions, setMaxQuestions ] = useState(1)
    const [ title, setTitle ] = useState("")

    const handleHours = (event ) => {
        setHours(event.target.value);
    };

    const handleMinutes = (event) => {
        setMinutes(event.target.value)
    }

    const handleSetLimit = (event) => {
        setMaxQuestions(event.target.value)
    }

    const handleSubmit = () => {

        if(!title){
            toast.error(t('nameRequired'))
            return
        } 
        dispatch(createQASession({
            title: title,
            churchId: profileChurch._id,
            allowAnonymous: allowAnonymous,
            questionVisibility: questionVisibility,
            requireApproval: requireApproval, 
            hasAutomaticExpiration: endAutomatically,
            hours: hours,
            minutes: minutes,
            limitQuestions: limitQuestions,
            maxQuestions: maxQuestions
        })) 
    }

    return (
        <CreateQASessionWrap>
            <ModalFormTop> 
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}> 
                    <TbMessage2Question style={{   marginRight: '10px'}} />  
                    <CreateItemModalHeading>
                        {t('create.title')}
                    </CreateItemModalHeading>
                </div>
                <ModalCloseButton 
                    handler={() => dispatch(setViewCreateQASessionModal(false))}
                    top='20px'
                    right='20px'
                    size='30px'
                    /> 
            </ModalFormTop>
            <OptionsContainer> 
                <ModalItemInput>
                    <MdOutlineDriveFileRenameOutline style={{color: 'grey', fontSize: '20px', marginRight: '10px'}} />
                    <input 
                        value={title} 
                        placeholder={"Session Name (Example: Sermon Q&A)"}
                        onChange={(e) => setTitle(e.target.value)} 
                        />
                </ModalItemInput>

                <OptionsWrap>
                    <TwoOptionButton
                        componentLabel={"Require Question Approval"}
                        label1={"Yes"}
                        label2={"No"}
                        value1={true}
                        value2={false}
                        valueToCheckIfSelected={requireApproval}
                        callback1={() => setRequireApproval(true)}
                        callback2={() => setRequireApproval(false)} 
                        />               
                    <OptionDescription>
                        {
                            requireApproval ? 
                            (
                                "All questions will require moderator approval. Questioner will see if their question was approved or rejected."
                            )
                            :
                            (
                                "All questions submitted by users will be automatically approved. You may consider limiting the number of questions a single user is allowed to ask per session."
                            )
                        }
                    </OptionDescription>     
                </OptionsWrap>  
                <OptionsWrap>
                    <TwoOptionButton
                        componentLabel={"Questions visibility"}
                        label1={"Private"}
                        label2={"Public"}
                        value1={"private"}
                        value2={"public"}
                        valueToCheckIfSelected={questionVisibility}
                        callback1={() => setQuestionVisibility("private")}
                        callback2={() => setQuestionVisibility("public")} 
                        />               
                    <OptionDescription>
                        {
                            questionVisibility === "private" ?
                            (
                                "Only church admins and moderators can see questions."
                            )
                            :
                            (
                                "All Praysely users can see approved questions"
                            )
                        }
                    </OptionDescription>     
                </OptionsWrap>              
                <OptionsWrap>
                    <TwoOptionButton
                        componentLabel={"Allow Anonymous Questions"}
                        label1={"Yes"}
                        label2={"No"}
                        value1={true}
                        value2={false}
                        valueToCheckIfSelected={allowAnonymous}
                        callback1={() => setAllowAnonymous(true)}
                        callback2={() => setAllowAnonymous(false)} 
                        />               
                    <OptionDescription>
                        {
                            allowAnonymous ? 
                            (
                                "Users may choose to ask anonymously. Names and profile images will not be displayed from anonymous questions."
                            )
                            :
                            (
                                "Name and profile image of questioner will be displayed."
                            )
                        }
                    </OptionDescription>     
                </OptionsWrap>  
                <OptionsWrap2>
                    <OptionsWrap>
                        <TwoOptionButton
                            componentLabel={"End session automatically"}
                            label1={"Yes"}
                            label2={"No"}
                            value1={true}
                            value2={false}
                            valueToCheckIfSelected={endAutomatically}
                            callback1={() => setEndAutomatically(true)}
                            callback2={() => setEndAutomatically(false)} 
                            />               
                        <OptionDescription>
                            {
                                endAutomatically ? 
                                (
                                    "End session after a set length of time from the start of session. Users may only submit questions during active sessions."
                                )
                                :
                                (
                                    "End session manually. Users may submit questions as long as session is active."
                                )
                            }
                        </OptionDescription>     
                    </OptionsWrap>    
                    {
                        endAutomatically && (
                            <EndAutomaticallyDiv>
                            <FormControl sx={{  m: 1, minWidth: 100, maxWidth: 220 }}>
                                <InputLabel id="demo-simple-select-label">Hours</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    sx={{
                                        height: 45
                                    }}
                                    value={hours}
                                    label="Hours"
                                    onChange={handleHours}
                                    >
                                    <MenuItem value={0}>0</MenuItem>    
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={6}>6</MenuItem>
                                    <MenuItem value={12}>12</MenuItem>
                                    <MenuItem value={24}>24</MenuItem>
                                    <MenuItem value={48}>48</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 100, maxWidth: 220 }}>
                                <InputLabel id="demo-simple-select-label">Minutes</InputLabel>
                                <Select
                                    sx={{
                                        height: 45
                                    }}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={minutes}
                                    label="Minutes"
                                    onChange={handleMinutes}
                                    > 
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                    <MenuItem value={40}>40</MenuItem>
                                    <MenuItem value={50}>50</MenuItem> 
                                </Select>
                            </FormControl>
                            </EndAutomaticallyDiv>
                        )
                    }                
                </OptionsWrap2>
                <OptionsWrap2>
                    <OptionsWrap>
                        <TwoOptionButton
                            componentLabel={"Limit Questions Per User"}
                            label1={"Yes"}
                            label2={"No"}
                            value1={true}
                            value2={false}
                            valueToCheckIfSelected={limitQuestions}
                            callback1={() => setLimitQuestions(true)}
                            callback2={() => setLimitQuestions(false)} 
                            />               
                        <OptionDescription>
                            {
                                limitQuestions ? 
                                (
                                    `Each user will be allowed a maximum of ${maxQuestions} approved question${maxQuestions > 1 ? "s" : ""} for this session.`
                                )
                                :
                                (
                                    "Users are not limited to the number of questions they can ask."
                                )
                            }
                        </OptionDescription>     
                    </OptionsWrap>    
                    {
                        limitQuestions && (
                            <EndAutomaticallyDiv>
                                <FormControl sx={{  m: 1, minWidth: 100, maxWidth: 220 }}>
                                    <InputLabel id="demo-simple-select-label">Max</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        sx={{
                                            height: 45
                                        }}
                                        value={maxQuestions}
                                        label="Max"
                                        onChange={handleSetLimit}
                                        >   
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                        <MenuItem value={4}>4</MenuItem>
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={6}>6</MenuItem>
                                        <MenuItem value={7}>7</MenuItem>
                                        <MenuItem value={8}>8</MenuItem>
                                        <MenuItem value={9}>9</MenuItem>
                                        <MenuItem value={10}>10</MenuItem>  
                                    </Select>
                                </FormControl> 
                            </EndAutomaticallyDiv>
                        )
                    }                
                </OptionsWrap2>
                            <ButttonWrap>
                <FileUploadButton
                    onClick={handleSubmit}
                    disabled={createQASessionStatus === "LOADING"}
                    style={{marginBottom: '20px'}}
                    width={'150px'}
                    >
                    { createQASessionStatus === "LOADING" ? 
                        (
                            <SpinnerSmall />
                        )
                        :
                        (
                            "Create"
                        )
                    }
                </FileUploadButton>
            </ButttonWrap>
            </OptionsContainer> 
        </CreateQASessionWrap>
    )
}
